var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Icon } from '../../../atoms/Icon';
// Styles
import { getSquareIconStyles } from '../../../common/styles/getSquareIconStyles';
// Utils
import styled from 'styled-components';
export var IconContainer = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), getSquareIconStyles('12px'));
var templateObject_1;
//# sourceMappingURL=IconContainer.js.map